'use strict';

var styled = require('styled-components');
var React = require('react');
var component = require('../ColoredCard/component.js');
var index = require('../Flex/index.js');
var styles = require('../Icon/styles.js');
var component$1 = require('../Text/component.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const StyledColoredCard = styled__default.default(component.ColoredCard) `
  position: relative;
`;
const CloseIconContainer = styled__default.default.div `
  padding: ${({ theme }) => theme.designTokens.bannerCloseIconPaddingY}
    ${({ theme }) => theme.designTokens.bannerCloseIconPaddingX};
  font-size: ${({ theme }) => theme.designTokens.bannerCloseIconFontSize};
  position: absolute;
  cursor: pointer;
  top: 0;
  right: 0;
  z-index: 2;
  & ${styles.Styled.Container} {
    color: ${({ theme }) => theme.designTokens.bannerCloseIconColor};
  }
`;
const FlexRow = styled__default.default(index.Flex.Row) `
  flex-wrap: nowrap;
`;
const HeadingText = styled__default.default(({ closeable, theme, ...props }) => React__default.default.createElement(component$1.Text, { ...props })) `
  margin-bottom: 0 !important;
  padding-right: ${({ closeable, theme }) => closeable && `calc(${theme.designTokens.bannerCloseIconFontSize} + ${theme.designTokens.bannerCloseIconPaddingX})`};
`;
const VariantIconContainer = styled__default.default.div `
  line-height: 1.5rem;
  font-size: 0;
  > i {
    font-size: 1rem;
  }
`;
const Styled = {
    CloseIconContainer,
    ColoredCard: StyledColoredCard,
    VariantIconContainer,
    FlexRow,
    HeadingText,
};

exports.Styled = Styled;
//# sourceMappingURL=styles.js.map
